import { loadStripe } from '@stripe/stripe-js'

import { useAdminUnauthorised, usePrincipal } from '../application/authentication'
import { pathWithOrigin } from '../util/dom'
import { useApiErrorHandlingAsyncCallback } from './auth'

const {
  stripe: { apiKey, stripeAccount },
} = CONFIG

interface StripeSetup {
  clientReference?: string
  successPath: string
  cancelPath: string
}

export const useStripeSetup = ({
  successPath,
  cancelPath,
  clientReference,
}: StripeSetup) => {
  const { apiClient } = usePrincipal()

  const adminUnauthorised = useAdminUnauthorised()

  return useApiErrorHandlingAsyncCallback(
    adminUnauthorised(async () => {
      const stripe = await loadStripe(apiKey, { stripeAccount })

      await stripe?.redirectToCheckout(
        await apiClient.stripeSetupSession({
          clientReference,
          cancelUrl: pathWithOrigin(cancelPath),
          successUrl: pathWithOrigin(successPath),
        }),
      )
    }),
  )
}
